import { useEffect, useId, useState } from "react";
import styles from "./ToggleSwitch.module.scss";

export interface ToggleSwitchProps {
  label?: string;
  value?: boolean;
  onChange?: (value: boolean) => void;
}

export function ToggleSwitch({
  label,
  value = false,
  onChange,
}: ToggleSwitchProps) {
  const [isOn, setIsOn] = useState(value);
  const id = useId();

  useEffect(() => {
    setIsOn(value);
  }, [value]);

  function toggle() {
    const newValue = !isOn;
    setIsOn(newValue);
    onChange?.(newValue);
  }

  return (
    <div className={styles.toggleContainer}>
      {label && <label htmlFor={id}>{label}</label>}
      <div className={styles.switchWrapper} onClick={toggle}>
        <input
          id={id}
          type="checkbox"
          checked={isOn}
          onChange={toggle}
          className={styles.input}
        />
        <span className={styles.slider} />
      </div>
    </div>
  );
}